module.exports = __webpack_public_path__ + "ccf63dda1756ca8f39ad5e2077bffde7.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/kiandra.jpg
 ** module id = 194
 ** module chunks = 0
 **/